<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio -->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsAssirete',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Salute", link : 'conv-assirete' } ],

        // variabili che definiscono il servizio Assirete con la quale
        // configuriamo la pagina di login.
        service_title: "Salute",
        service: "assirete",
        cluster: "home",
        comp_credito: "totale"
    }
  },
  components: {
    PageTagline,
    TsLoginPage
  }
}
</script>

<style scoped></style>